import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-ignore-accents',
  templateUrl: './pdf-find-ignore-accents.component.html',
  styleUrls: ['./pdf-find-ignore-accents.component.css'],
})
export class PdfFindIgnoreAccentsComponent {}
